module.exports = __webpack_public_path__ + "img/img-05.3c7a8f65.jpg";